import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MedicalExamCertificateModule } from '../medical-review/components/medical-exam-certificate/medical-exam-certficate.module';
import { CustomerSearchBarModule } from '../shared/components/customer-searchbar/customer-search-bar.module';
import { ValidationResultsModule } from '../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { MedicalExamCertificateMegaMenuModalComponent } from './credential/issuance/requirement/medical-exam-certificate-megamenu-modal.component';

@NgModule({
    declarations: [
        MedicalExamCertificateMegaMenuModalComponent
    ],
    imports: [
        CommonModule,
        CustomerSearchBarModule,
        MedicalExamCertificateModule,
        MVMSpinnerBtnModule,
        ValidationResultsModule,
    ],
})
export class DriverModalsModule {
}
